import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { enabled: Boolean };

  connect() {
    if (this.enabledValue) this.element.focus();
  }
}
